import React from 'react';
import { Box, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface FloatingViewPackagesButtonProps {
  isVisible: boolean;
  isBottomNavVisible: boolean;
  onScrollToFormSection: () => void;
}

const FloatingViewPackagesButton: React.FC<FloatingViewPackagesButtonProps> = ({
  isVisible,
  isBottomNavVisible,
  onScrollToFormSection,
}) => {
  const { t } = useTranslation(['validate']);

  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 1301,
        display: { xs: 'flex', md: 'none' },
        justifyContent: 'center',
        paddingBottom: isBottomNavVisible ? '8px' : '0px',
        transform: isVisible ? 'translateY(0)' : 'translateY(100%)',
        opacity: isVisible ? 1 : 0,
        transition: 'transform 0.3s ease-in-out, opacity 0.3s ease-in-out',
        pointerEvents: isVisible ? 'auto' : 'none',
        backgroundColor: 'transparent',
      }}
    >
      <Button
        variant="contained"
        color="primary"
        sx={{
          m: 2,
          borderRadius: 8,
          width: '90%',
          fontWeight: 700,
          fontSize: 18,
          boxShadow: 3,
          pointerEvents: 'auto',
        }}
        onClick={onScrollToFormSection}
      >
        {t('validate:view_packages')}
      </Button>
    </Box>
  );
};

export default FloatingViewPackagesButton;
